/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量4
 * @export
 * @interface Col4
 */
export interface Col4 {
}

/**
 * Check if a given object implements the Col4 interface.
 */
export function instanceOfCol4(value: object): value is Col4 {
    return true;
}

export function Col4FromJSON(json: any): Col4 {
    return Col4FromJSONTyped(json, false);
}

export function Col4FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col4 {
    return json;
}

export function Col4ToJSON(json: any): Col4 {
    return Col4ToJSONTyped(json, false);
}

export function Col4ToJSONTyped(value?: Col4 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

